import { render, staticRenderFns } from "./MdtTableAdditionalFilters.vue?vue&type=template&id=ca0cfdd4&scoped=true"
import script from "./MdtTableAdditionalFilters.vue?vue&type=script&lang=js"
export * from "./MdtTableAdditionalFilters.vue?vue&type=script&lang=js"
import style0 from "./MdtTableAdditionalFilters.vue?vue&type=style&index=0&id=ca0cfdd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0cfdd4",
  null
  
)

export default component.exports